import {
    Divider,
    Space,
    Typography,
} from 'antd';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../PageHeader';
import ItemData from './Item';
import { IBooking } from '../../interfaces/booking.interface';

const { Title } = Typography;

const OtherDetails: FC<Partial<IBooking>> = ({
    bookingNotes,
    externalBookingId,
}) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });

    return (
        <Space direction="vertical" size={12}>
            <PageHeader
                title={(
                    <Title level={5} style={{ marginBottom: 0 }}>
                        {t('OTHER_DETAILS')}
                    </Title>
                )}
                footer={<Divider />}
            />
            <Space direction="vertical" size={12}>
                <ItemData
                    label={t('EXTERNAL_ID')}
                    value={externalBookingId || t('NO_EXTERNAL_ID')}
                />
                <ItemData
                    label={t('NOTES')}
                    value={bookingNotes || t('EMPTY_NOTES')}
                />
            </Space>
        </Space>
    );
};

export default memo(OtherDetails);
